export default {
    app: {
        name: 'BZUCO Inspector',
        reseted: 'Jegyek visszaállítva...',
        networkError: 'Szerverhiba, kérjük, ellenőrizze az internetkapcsolatot...',
        networkNotAvailable: 'Nincs kapcsolat'
    },
    menu: {
        test: 'Vonalkódolvasó teszt',
        settings: 'Beállítások',
        admin: 'Adminisztráció',
        resetTickets: 'Jegyek visszaállítása',
        resetState: 'Alkalmazás visszaállítása',
        logout: 'Kijelentkezés'
    },
    home: {
        login: 'Bejelentkezés',
        lastEvent: 'Utoljára kiválasztott esemény / zóna ellenőrzése',
        lastEvents: 'Utoljára betöltött<br />események ellenőrzése',
        lastZones: 'Utoljára betöltött<br />zónák ellenőrzése',
        chooseEvent: 'Esemény kiválasztása',
        checkEvents: 'Események<br />ellenőrzése',
        checkZones: 'Zónák<br />ellenőrzése',
        scanConfig: 'Scan QR code'
    },
    configScanner: {
        title: 'Configuration QR',
        notConfig: 'Unrecognized configuration code',
        loggedIn: 'Logged in:',
        setsSelected: 'Selected ticketsets:',
        zonesSelected: 'Selected zone:',
        loginRequiredTitle: 'Login required',
        loginRequiredMessage: 'You need to log in before loading ticketsets or zones.',
        ok: 'OK'
    },
    event: {
        chooseEvent: 'Esemény kiválasztása',
        chooseEventPast: 'Korábbi események',
        confirm: 'Esemény kiválasztásának megerősítése',
        showPast: 'korábbiak megjelenítése'
    },
    zone: {
        chooseZone: 'Zóna(k) kiválasztása',
        confirm: 'Zóna kiválasztásának megerősítése'
    },
    ticketsets: {
        chooseTicketsets: 'Jegykészletek kiválasztása',
        selectAll: 'Mindet kijelölni',
        ticketCount: 'Jegyek száma:'
    },
    scanner: {
        tickets: 'Jegyek:',
        startReader: 'Olvasó indítása',
        startReaderDescription:
            'A böngészőnek felhasználói interakcióra van szüksége a rendszerhangok lejátszásához. Erősítse meg az "OK" gombbal.',
        specialWarning: 'Figyelmeztetés',
        specialType: 'Speciális típusú jegy:',
        refuse: 'Elutasít',
        confirm: 'Megerősít',
        messageSuccess: '{code} kód elfogadva',
        messageSuccessPrice: '{code} kód elfogadva<br /><big>Ár: <b>{price}</b></big>',
        messageSuccessTicketsetPrice: '{code} kód elfogadva<br /><big>Készlet: <b>{ticketset} / {price}</b></big>',
        messageSuccessTicketset: '{code} kód elfogadva<br /><big>Készlet: <b>{ticketset}</b></big>',
        messageSuccessEvent: '{code} kód elfogadva<br /><big>Esemény: <b>{event}</b>, készlet: {ticketset}</big>',
        messageSuccessNosend: '{code} kód elfogadva (nincs elküldve)',
        messageRead: '{code} kód beolvasva',
        messageUsed: '{code} kód már használva',
        messageNotUsable: '{code} kód nem használható',
        messageUnsend: '{code} kód már használva (általam, nincs elküldve)',
        messageNotFound: '<b>{code}</b> kód nem található',
        messageBadSlot: '{code} kód nem érvényes ehhez a zónához/időponthoz',
        messageExtra1: 'felhasználva eszközön: <b>{device}</b>, dátum: <b>{date}</b>',
        manualTitle: 'Kód manuális megadása',
        loading: 'jegyek betöltése...',
        nfcNotFound: 'A kártyán nincs érvényes jegy'
    },
    login: {
        title: 'Bejelentkezés az alkalmazásba',
        username: 'Felhasználónév',
        password: 'Jelszó',
        login: 'Bejelentkezés'
    },
    settings: {
        title: 'Beállítások',
        sound: 'Hang',
        soundSub: 'Hangértesítések engedélyezése',
        camera: 'Kamera',
        nfc_heading: 'NFC',
        nfc: 'NFC címkék olvasása',
        language: 'Nyelv',
        langCs: 'Cseh',
        langEn: 'Angol',
        langDe: 'Német',
        langHr: 'Horvát',
        langHu: 'Magyar',
        langPl: 'Lengyel',
        langSk: 'Szlovák',
        qTitle: 'Speciális kamera beállítások',
        qPatchSize: 'Dekódolási ablak mérete',
        qFrequency: 'Dekódolási frekvencia',
        groupDisplay: 'Csoport / kategória megjelenítése ellenőrzéskor',
        groupDisplayNone: 'Semmit ne mutass',
        groupDisplayTicketset: 'Jegykészlet neve',
        groupDisplayTicketsetPrice: 'Jegykészlet és ár',
        groupDisplayPrice: 'Ár',
        groupDisplayEvent: 'Esemény és jegykészlet',
        olderEvents: 'Mennyi ideig mutassa a régebbi eseményeket',
        olderEventsWeek: 'Egy hét',
        olderEventsMonth: 'Egy hónap',
        olderEvents3Month: '3 hónap',
        olderEvents6Month: '6 hónap',
        olderEventsYear: '1 év',
        olderEventsAll: 'Összes esemény mutatása',
        olderEventsAllList: 'mind',
        showTicketCount: 'Jegyek számának mutatása',
        showStatistics: 'Statisztika megjelenítése',
        queueTitle: 'Küldési sorban lévő kódok',
        queueSending: 'küldés folyamatban',
        queueYes: 'IGEN',
        queueNo: 'NEM',
        queueEmpty: 'A sor üres'
    },
    statistics: {
        title: 'Jegyhasználat statisztikája',
        zone: 'Zóna',
        today: 'Ma',
        total: 'Összesen',
        refresh: 'Adatok frissítése'
    },
    verify: {
        title: 'Jegy ellenőrzése',
        enterCode: 'Adja meg a jegy kódját',
        verify: 'Ellenőrzés',
        scanHint: 'Olvasson be egy kódot vagy adja meg kézzel',
        notFound: 'Jegy nem található',
        found: 'Jegy megtalálva',
        email: 'E-mail',
        entries: 'Belépések',
        people: 'Személyek',
        entryPause: 'Belépési szünet (perc)',
        purchased: 'Vásárolva',
        validUntil: 'Érvényes eddig',
        event: 'Esemény',
        ticketset: 'Jegykészlet',
        price: 'Árszint',
        zones: 'Zónák',
        noZones: 'A jegy nincs zónához rendelve.',
        slots: 'Időpontok',
        noSlots: 'A jegy nincs időponthoz rendelve.',
        usageForZone: 'Használat a zónában',
        remains: 'Hátralévő',
        usageLogs: 'Jegyhasználati napló',
        showDebug: 'Q',
        debugQuery: 'Query',
        debugData: 'Data',
        newSearch: 'Új ellenőrzés'
    }
} as const
